import React, { useState, useEffect, useRef } from 'react';
import { useAuth } from '../../auth/AuthContext';
import { profileApi } from '../../api/profileApi';
import { isApiConfigured } from '../../api/axiosClient';
import { LoadingSpinner, ErrorCard } from '../../components/LoadingSpinner';
import { Input, MaskedTextBox, Switch } from '@progress/kendo-react-inputs';
import '@progress/kendo-theme-default/dist/all.css';
import { Label } from '@progress/kendo-react-labels';
import { Button } from '@progress/kendo-react-buttons';
import { Form, Field, FormElement } from '@progress/kendo-react-form';
import { Error } from '@progress/kendo-react-labels';
import { ShieldCheck, Smartphone, Mail, Key, Lock, CheckCircle, XCircle, Shield, Hash, Plus, AlertTriangle } from 'lucide-react';
import { useToast } from '../../components/Toast';
import { useConfirm } from '../../components/ConfirmDialog';
import LoginActivityCard from '../../components/LoginActivityCard';

import { FieldWrapper } from '@progress/kendo-react-form';
import { ValidatedInput } from '../../components/ValidatedInput';
import {
    Users, UserCheck, UserX, UserPlus, Search, LayoutGrid, List,
     Phone, Edit2, Trash2, Power, Circle, MoreVertical, Filter,
    AtSign, Check, AlertCircle, Eye, EyeOff, Copy,
} from 'lucide-react';
import  ImpersonationActivityCard  from '../../components/ImpersonationActivityCard';

const ProfilePage = () => {

    const [loading, setLoading] = useState(false);
    const requiredValidatorFirstName = (value) => (value ? '' : 'First name is required');
    const requiredValidatorLastName = (value) => (value ? '' : 'Last name is required');

    const requiredValidatorCurrentPassword = (value) => (value ? '' : 'Current password is required');
    const requiredValidatorNewPassword = (value) => (value ? '' : 'New password is required');
    const requiredValidatorConfirmPassword = (value) => (value ? '' : 'Confirm password is required');
    

    const generatePassword = (length = 14) => {
        const upper = 'ABCDEFGHJKLMNPQRSTUVWXYZ';
        const lower = 'abcdefghjkmnpqrstuvwxyz';
        const digits = '23456789';
        const symbols = '!@#$%^&*-_+=?';
        const all = upper + lower + digits + symbols;

        const randomInt = (max) => {
            const buf = new Uint32Array(1);
            (window.crypto || window.msCrypto).getRandomValues(buf);
            return buf[0] % max;
        };

        // Guarantee at least one char from each category.
        const chars = [
            upper[randomInt(upper.length)],
            lower[randomInt(lower.length)],
            digits[randomInt(digits.length)],
            symbols[randomInt(symbols.length)],
        ];
        while (chars.length < length) {
            chars.push(all[randomInt(all.length)]);
        }
        // Fisher-Yates shuffle so the guaranteed chars aren't always at the start.
        for (let i = chars.length - 1; i > 0; i--) {
            const j = randomInt(i + 1);
            [chars[i], chars[j]] = [chars[j], chars[i]];
        }
        return chars.join('');
    };
    const [pwdNew, setPwdNew] = useState('');
    const [pwdConfirm, setPwdConfirm] = useState('');
    const [pwdReveal, setPwdReveal] = useState(false);
    const [pwdSaving, setPwdSaving] = useState(false);

    const emailValidator = (value) =>
        value && /\S+@\S+\.\S+/.test(value) ? '' : 'Invalid email';

    //const phoneValidator = (value) =>
    //    value && value.indexOf('_') === -1 ? '' : 'Invalid phone number';

    //const phoneValidator = (value) =>
    //    /^\(\d{3}\)\s\d{3}-\d{4}$/.test(value)
    //        ? ''
    //        : 'Invalid phone number';

    //const phoneValidator = (value) => {

    //    alert("PHONE VALUE : "+value);
    //    if (!value || value.includes('_')) {
    //        return '';
    //    }
    //    return /^\(\d{3}\)\s\d{3}-\d{4}$/.test(value)
    //        ? ''
    //        : 'Invalid phone number';
    //};

    const phoneValidator = (value) => {
        const digits = (value || '').replace(/\D/g, '');

        return digits.length === 0 || digits.length === 10
            ? ''
            : 'Invalid phone number';
    };
   

    const MaskedTextBoxField = (fieldRenderProps) => {
        const {
            validationMessage,
            touched,
            label,
            id,
            ...others
        } = fieldRenderProps;

        return (
            <FieldWrapper>
                <Label editorId={id}>{label}</Label>

                <MaskedTextBox
                    id={id}
                    {...others}
                />

                {touched && validationMessage && (
                    <Error>{validationMessage}</Error>
                )}
            </FieldWrapper>
        );
    };

    

    const strongPasswordValidator = (value) => {
        if (!value) return undefined;

        const minLength = value.length >= 8;
        const hasUpper = /[A-Z]/.test(value);
        const hasLower = /[a-z]/.test(value);
        const hasNumber = /\d/.test(value);
        const hasSpecial = /[!@#$%^&*(),.?":{}|<>]/.test(value);

        if (!minLength || !hasUpper || !hasLower || !hasNumber || !hasSpecial) {
            return "Password must be at least 8 characters and include uppercase, lowercase, number, and special character";
        }

        return undefined;
    };

    const matchPasswordValidator = (getValue) => (value) => {
        if (!value) return undefined;

        return value === getValue()
            ? undefined
            : "Passwords do not match";
    };

    const styles = {
        overlay: {
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            background: 'rgba(255,255,255,0.7)',
            zIndex: 9999,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
        }
    };
    

    //const FormInput = (fieldRenderProps) => {
    //    const {
    //        validationMessage,
    //        touched,
    //        label,
    //        id,
    //        valid,
    //        ...others
    //    } = fieldRenderProps;

    //    return (
    //        <div className="k-form-field">
    //            <Label htmlFor={id}>{label}</Label>

    //            <Input
    //                id={id}
    //                {...others}
    //                valid={valid}
    //            />

    //            {touched && validationMessage && (
    //                <Error>{validationMessage}</Error>
    //            )}
    //        </div>
    //    );
    //};


    const FormInput = (fieldRenderProps) => {
        const {
            validationMessage,
            touched,
            label,
            id,
            valid,
            type,
            ...others
        } = fieldRenderProps;

        const [showPassword, setShowPassword] = React.useState(false);

        const isPassword = type === "password";

        return (
            <div className="k-form-field">
                <Label htmlFor={id}>{label}</Label>

                <div style={{ position: "relative", display: "flex", alignItems: "center" }}>
                    <Input
                        id={id}
                        {...others}
                        type={isPassword && !pwdReveal ? "password" : "text"}
                        valid={valid}
                        style={{ paddingRight: isPassword ? "40px" : undefined }}
                    />

                    {isPassword && (
                        <span
                            onClick={() => setShowPassword((prev) => !prev)}
                            style={{
                                position: "absolute",
                                right: 10,
                                cursor: "pointer",
                                userSelect: "none",
                                fontSize: 16
                            }}
                            title={showPassword ? "Hide password" : "Show password"}
                        >
                            {/*{showPassword ? "🙈" : "👁"}*/}
                        </span>
                    )}
                </div>

                {touched && validationMessage && (
                    <Error>{validationMessage}</Error>
                )}
            </div>
        );
    };

    const { user, mfaEmailEnabled, setMfaEmailEnabled } = useAuth();
    const toast = useToast();
    const confirm = useConfirm();
   // const { user } = useAuth();
    const [userProfile, setUserProfile] = useState([]);


    const isAdmin = user?.userRole?.trim().toLowerCase() === 'provider admin';

    


    

    /* ── Email-MFA toggle (settings-level). When enabled, the login flow
     *    sends a 6-digit code to the user's email; when disabled, login
     *    proceeds after password only. This is the simple email-only MFA
     *    control the Settings page exposes. ─────────────────────────── */
    const [emailMfaStep, setEmailMfaStep] = useState('idle'); // idle | verify
    const [emailMfaCode, setEmailMfaCode] = useState('');
    const [verificationSecretKey, setVerificationSecretKey] = useState('');
    const [emailMfaError, setEmailMfaError] = useState('');
    const [emailMfaSaving, setEmailMfaSaving] = useState(false);
    const [eventsData, setEventsData] = useState('');

    const handleBeginEnableEmailMfa = async () => {
        setEmailMfaError('');
        setEmailMfaSaving(true);
        // Simulate sending a 6-digit code to the user's email.
        if (isApiConfigured()) {
            setLoading(true);  // Start loader
            try {
                //await profileApi.updateProfile({ mfaEmailEnabled: true, stage: 'send_code' });
                var res = await profileApi.sendMFAEnableVerCode({ email: user.email });
                if (res.success) {
                    //set verification secret key from res
                    setVerificationSecretKey(res.data);
                    setEmailMfaStep('verify');
                    setEmailMfaSaving(false);
                    
                }
                else {
                    setEmailMfaError('Failed to send verification email. Try again.');
                    setEmailMfaSaving(false);
                    
                    
                }
                setLoading(false);  // Stop loader
                
            } catch {
                setEmailMfaError('Failed to send verification email. Try again.');
                setEmailMfaSaving(false);
                setLoading(false);  // Stop loader
                return;
            }
        } else {
            await new Promise((r) => setTimeout(r, 600));
        }
        //setEmailMfaSaving(false);
        //setEmailMfaStep('verify');
    };

    const handleConfirmEnableEmailMfa = async () => {
        setEmailMfaError('');
        
        if (emailMfaCode.length !== 6) {
            setEmailMfaError('Enter the 6-digit code from your email.');
            return;
        }
        setEmailMfaSaving(true);
        if (isApiConfigured()) {
            try {
                //await profileApi.updateProfile({
                //    mfaEmailEnabled: true,
                //    verificationCode: emailMfaCode,
                //});
                var res = await profileApi.verifyMFAEnableVerCode({
                    email: user.email,
                    verificationSecretKey: verificationSecretKey,
                    verificationCode: emailMfaCode
                });

                if (res.success) {
                    setMfaEmailEnabled(true);
                    setEmailMfaStep('idle');
                }
                else {
                    setEmailMfaError('Invalid code. Check your email and try again.');
                    setEmailMfaStep('verify');
                    setEmailMfaSaving(false);
                }
                
            } catch {
                setEmailMfaError('Invalid code. Check your email and try again.');
                setEmailMfaSaving(false);
                return;
            }
        } else {
            await new Promise((r) => setTimeout(r, 400));
            if (emailMfaCode !== '123456') {
                setEmailMfaError('Invalid code. Demo mode expects 123456.');
                setEmailMfaSaving(false);
                return;
            }
        }
        //setMfaEmailEnabled(true);
        setEmailMfaSaving(false);
        
        setEmailMfaCode('');
    };

    const handleDisableEmailMfa = async () => {
        const ok = await confirm({
            title: 'Disable Email MFA?',
            message: 'Your account will be less secure — future sign-ins will not require an email code.',
            confirmLabel: 'Disable MFA',
            cancelLabel: 'Keep it on',
            variant: 'warning',
        });
        if (!ok) return;
        if (isApiConfigured()) {
            try {
               var res= await profileApi.update2FA({
                   username: user.userName,
                   enable: false 
               });

                if (res.success) {
                    setMfaEmailEnabled(false);
                    toast.warning('Email MFA is now off.', { title: 'MFA disabled' });
                }
                
            }
            catch
            {
                toast.error('Oops! Something went wrong ', { title: 'MFA disabled error' });
            }
        }
       // setMfaEmailEnabled(false);
        setEmailMfaStep('idle');
        setEmailMfaCode('');
        setEmailMfaError('');
        
    };


    //const [formData, setFormData] = useState({
    //    firstName: userProfile?.firstName?.replace(/^Dr\.\s*/, '') || '',
    //    lastName: userProfile?.lastName || '',
    //    email: userProfile?.email || '',
    //    phone: userProfile?.orgPhone || '',
    //    organizationName: userProfile?.orgName || '',
    //});


    const [formData, setFormData] = useState({
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
        organizationName: '',
        //taxIds: [],
        taxIds: [user?.taxId || ''],
        taxIdAttestation: false,
    });

    const [passwords, setPasswords] = useState({
        currentPassword: '',
        newPassword: '',
        confirmPassword: '',
    });

    const [twoFactorEnabled, setTwoFactorEnabled] = useState(false);
    const [twoFaEnabled, setTwoFaEnabled] = useState(false);

    //const [notifications, setNotifications] = useState({
    //    claims: true,
    //    authorizations: true,
    //    invoices: true,
    //    systemUpdates: false,
    //});

    const [notifications, setNotifications] = useState({});

    const [savingProfile, setSavingProfile] = useState(false);
    const [savingPassword, setSavingPassword] = useState(false);


    const handleProfileChange = (field, value) => {
        setFormData((prev) => ({ ...prev, [field]: value }));
    };

    const handlePasswordChange = (field, value) => {
        setPasswords((prev) => ({ ...prev, [field]: value }));
    };

    const handleNotificationChange =async (key) => {
        //setNotifications((prev) => ({ ...prev, [field]: !prev[field] }));

        let selectedValues = [];
        setNotifications((prev) => {
            const updated = {
                ...prev,
                [key]: !prev[key],
            };

           selectedValues = Object.keys(updated).filter(
                (k) => updated[k]
            );

           // console.log(selectedValues); // latest selected values

            return updated;
        });

        //alert("UPDATED : " + selectedValues);
        //console.log("UPDATED : " + selectedValues);
        //return;

        if (isApiConfigured()) {

            setLoading(true);   //START loader

            try {
                
                const res = await profileApi.updateNotificationPreferences({ notificationPreferences : selectedValues });

                if (res.success) {
                    toast.success(res.message, { title: 'User profile' });
                }
                else {
                    toast.error(res.message, { title: 'User profile' });
                }

                setLoading(false);

            } catch (err) {
                setLoading(false);
                console.log("Error : " + err);
                toast.error("Oops! Something went wrong...", { title: 'User profile' });
            } finally {
                
                setLoading(false);   //STOP loader
            }
        } else {
            toast.error("Oops! Something went wrong... ", { title: 'User profile' });
        }

       // alert("Updated Notifications :"+JSON.stringify(notifications));
    };

    const cleanPhone = (value) => {
        return (value || '').replace(/\D/g, '');
    };



    const handleSaveProfile = async (dataItem) => {
        
        if (isApiConfigured())
        {              
            if (user?.userRole?.trim().toLowerCase() === 'provider admin')
            {

                const hasInvalidTaxIds =
                    dataItem.taxIds?.some((x) => {
                        const value = x?.trim();

                        return (
                            !value ||
                            value === "__-_______" ||
                            !/^\d{2}-\d{7}$/.test(value)
                        );
                    });


                if (hasInvalidTaxIds) {
                    toast.error("Please enter a valid Tax ID in the format 12-3456789.");
                    return;
                }


                const ids = dataItem.taxIds;

                const duplicates = ids.filter((id, index) => ids.indexOf(id) !== index);

                if (duplicates.length > 0) {
                    toast.error(
                        `Duplicate Tax ID(s): ${[...new Set(duplicates)].join(", ")} found`, { title: 'Profile' }
                    );
                    return;
                }

            }



            
            // Block save when additional Tax IDs are present and the admin hasn't
            // checked the attestation box. The disclaimer is the legal record.

           
            if (taxIdAttestationRequired && !formData.taxIdAttestation) {
                toast.error(
                    'Please acknowledge the Tax ID attestation before saving.',
                    { title: 'Attestation required' },
                );
                return;
            }
            
            setSavingProfile(true);

            
            try {
                var res=await profileApi.updateProfile({
                    userId:user.userId?.trim(),
                    firstName: dataItem.firstName,
                    lastName: dataItem.lastName,
                    phone: cleanPhone(dataItem.phone),
                    orgName: dataItem.organizationName,
                    userRole: user.userRole?.trim(),                    
                    //taxIds: (dataItem.taxIds || [])
                    //    .map(x => String(x ?? '').trim())
                    //    .filter(Boolean)

                    taxIds: user?.userRole?.trim().toLowerCase()==='super admin'? [] : (dataItem.taxIds || [])   // return empty array if user is super admin for others return taxid string array
                        .map(x => String(x ?? "").replace(/\D/g, ""))
                        .filter(x => x && x !== "__-_______")                    
                });

                
                if (res.success) {
                    toast.success("Profile updated successfully", { title: 'Profile update' });
                    getUserProfile();

                    //setTimeout(() => {
                    //    location.reload();
                    //}, 3000); // 3000 milliseconds = 3 seconds
                }
                else {
                    toast.error(res.message, { title: 'Profile update' });
                }
                
            } catch (err) {
                console.log("Error at handleSaveProfile : "+err);
                toast.error("Failed to update profile", { title: 'Profile update' });
            } finally {
                setSavingProfile(false);
            }
        } else {
            toast.success("Profile updated successfully", { title: 'Profile update' });
        }
    };

    const formatPhone = (value) => {
        if (!value) return '';

        const cleaned = value.replace(/\D/g, '');

        if (cleaned.length !== 10) return value;

        return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3, 6)}-${cleaned.slice(6)}`;
    };
    const formatTaxId = (value) => {
        if (!value) return "";

        const cleaned = value.replace(/\D/g, "");

        if (cleaned.length !== 9) return value;

        return `${cleaned.slice(0, 2)}-${cleaned.slice(2)}`;
    };

    const getUserProfile = async () => {
        if (isApiConfigured()) {

            setLoading(true);   //START loader

            try {
                const userName = user.userName;
                const res = await profileApi.getProfile({ userName });
                                
                setUserProfile(res.data);

                const value = res?.data?.notificationPreferences || "";                

                const notifications = value
                    ? value.split("|").reduce((acc, item) => {
                        const trimmed = item.trim();
                        if (trimmed) acc[trimmed] = true;
                        return acc;
                    }, {})
                    : {};

                setNotifications(notifications);


                //alert(res?.data?.TaxID);
                
                setFormData({
                    firstName: res.data?.firstName?.replace(/^Dr\.\s*/, '') || '',
                    lastName: res.data?.lastName || '',
                    email: res.data?.email || '',
                    phone: formatPhone(res.data?.phone) || '',
                    organizationName: res.data?.orgName || '',
                    
                    //taxIds: res?.data?.TaxID
                    //    ? res.data.TaxID.split('|')
                    //    : [''],
                    taxIds: res.data?.TaxID
                        ? res.data.TaxID.split("|").map(formatTaxId)
                        : [""],
                    taxIdAttestation: false
                });

              //  console.log("FORM DATA : "+JSON.stringify(formData));


              //  alert(JSON.stringify(formData));

                if (res.data?.twofactorrequired?.toLowerCase() == 'true') {

                    setTwoFactorEnabled(true);
                    setMfaEmailEnabled(true);

                }
                else {
                    setMfaEmailEnabled(false);
                }
                

            } catch (err) {
                console.log("Error : "+err);
                toast.error("Oops! Something went wrong...", { title: 'User profile' });
            } finally {
                setSavingProfile(false);
                setLoading(false);   //STOP loader
            }
        } else {
            toast.success("User profile get successfully ", { title: 'User profile' });
        }
    };

    const handleToggle2FA = async (value) => {

        
        setTwoFactorEnabled(value);

        try {
            const res=await profileApi.update2FA({
                enable: value,
                username:user.userName
            });
            //alert(res.message);
            toast.success(res.message, { title: '2FA update' });
        } catch (err) {
            //alert('Failed to update 2FA');
            toast.error('Failed to update 2FA', { title: '2FA update' });
        }
    };
    const handleUpdatePassword = async (dataItem) => {

        if (isApiConfigured()) {
            setSavingPassword(true);
            try {
              const res=  await profileApi.changePassword({
                    currentPassword: dataItem.currentPassword,
                    newPassword: dataItem.newPassword,
                    userName:user.userName
              });

                if (res.success) {
                    toast.success("Password updated successfully", { title: 'Password update' });
                    
                }
                else {
                    toast.error(res.message, { title: 'Password update' });
                    
                }
                
                setPasswords({ currentPassword: '', newPassword: '', confirmPassword: '' });
            } catch (err) {
                console.log("ERRO  : " + err);

                toast.error('Failed to update password', { title: 'Password update' });
            } finally {
                setSavingPassword(false);
            }
        } else {
            // alert('Password updated successfully! (demo only)');
            toast.success("Password updated successfully", { title: 'Password update' });
            setPasswords({ currentPassword: '', newPassword: '', confirmPassword: '' });
        }
    };

    useEffect(() => {
        if (user?.userName) {
            getUserProfile();

        }
    }, [user]);

    /* Tax ID list handlers — admin-only. The list always keeps at least one
   * row so the layout doesn't collapse to an empty state. */
    const handleTaxIdChange = (idx, value) => {
        
        setFormData((prev) => {
            const next = [...prev.taxIds];
            next[idx] = value;
            return { ...prev, taxIds: next };
        });

        
    };

    const initialTaxIdsRef = useRef([]);

    useEffect(() => {
        initialTaxIdsRef.current = formData?.taxIds || [];
    }, [formData]);

    //const handleAddTaxId = (formRenderProps) => {
        
    //    // setFormData((prev) => ({ ...prev, taxIds: [...prev.taxIds, ''] }));

    //    const current = formRenderProps.valueGetter('taxIds') || [];

    //    formRenderProps.onChange('taxIds', {
    //        value: [...current, '']
    //    });
    //};

    //const handleRemoveTaxId = (formRenderProps, idx) => {
    //    //setFormData((prev) => ({
    //    //    ...prev,
    //    //    taxIds: prev.taxIds.filter((_, i) => i !== idx).length
    //    //        ? prev.taxIds.filter((_, i) => i !== idx)
    //    //        : [''],
    //    //}));

    //    const next = (formRenderProps.valueGetter('taxIds') || [])
    //        .filter((_, i) => i !== idx);

        

    //    formRenderProps.onChange('taxIds', {
    //        value: next
    //    });
    //};

    /* Compute whether the Tax IDs have changed from their initial state.
     * The signature is the sorted list of trimmed non-empty values so that:
     *   - empty new rows alone don't trigger attestation
     *   - editing the Primary Tax ID DOES trigger attestation
     *   - reordering / re-adding the same values back does NOT trigger it
     * If anything has changed AND the user is an admin, attestation is
     * required and the disclaimer panel must be acknowledged before Save.
     * ──────────────────────────────────────────────────────────────────── */
    //const taxIdSignature = (arr) =>
    //    arr.map((t) => t.trim()).filter(Boolean).sort().join('|');

    const taxIdSignature = (arr = []) =>
        arr
            .map(t => String(t ?? '').trim())
            .filter(Boolean)
            .sort()
            .join('|');
    //const initialTaxIdSignatureRef = useRef(taxIdSignature(userProfile?.TaxID));
    const initialTaxIdSignatureRef = useRef(taxIdSignature(formData?.taxIds));
    //const taxIdsChanged =
    //    taxIdSignature(userProfile?.TaxID) !== initialTaxIdSignatureRef.current;
    //const taxIdAttestationRequired = isAdmin && taxIdsChanged;


    const taxIdsChanged =
        taxIdSignature(formData?.taxIds) !== initialTaxIdSignatureRef.current;


  //  const taxIdAttestationRequired = isAdmin && taxIdsChanged;

    let taxIdAttestationRequired = false;
    //console.log("taxIdsChanged : " + taxIdsChanged);


    return (        
        
        <div className="main-content">
            {loading && (
                <div style={styles.overlay}>
                    <LoadingSpinner data-cy="page-loader-profile" message="Please wait..." fullPage="true" />
                </div>
            )}
            <style>{`
                        input.k-input, #phone
                        {
                            padding:10px 14px !important;                            
                        }
                        .k-button-text
                        {
                            color:#fff;
                        }
            `}</style>
            <div className="page-header">
                <div>
                    <h1>Profile & Settings</h1>
                    <p>Manage your account information and preferences</p>
                </div>
            </div>

            {/* User Info Card */}
            <div className="card">
                <div style={{ display: 'flex', alignItems: 'center', gap: 16, marginBottom: 20 }}>
                    <div
                        style={{
                            width: 56,
                            height: 56,
                            borderRadius: 16,
                            background: 'linear-gradient(135deg, #0F766E, #0D9488)',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            color: '#fff',
                            fontSize: 22,
                            fontWeight: 700,
                        }}
                    >
                        {userProfile?.firstName?.charAt(0) || 'U'}
                        {userProfile?.lastName?.charAt(0) || ''}
                    </div>
                    <div>
                        <div style={{ fontSize: 18, fontWeight: 700, color: '#1A1D21' }}>
                            {userProfile?.firstName} {userProfile?.lastName}
                        </div>
                        <div style={{ fontSize: 13, color: '#6B7280' }}>{userProfile?.userRole}</div>
                    </div>
                </div>

                <div className="detail-grid">
                    <div className="detail-row">
                        <span className="detail-label">Full Name</span>
                        <span className="detail-value">
                            {userProfile?.firstName } {userProfile?.lastName}
                        </span>
                    </div>
                    <div className="detail-row">
                        <span className="detail-label">Email</span>
                        <span className="detail-value">{userProfile?.email ?? '-'}</span>
                    </div>
                    <div className="detail-row">
                        <span className="detail-label">Org Phone</span>
                        <span className="detail-value">{userProfile?.orgPhone ?? '-'}</span>
                    </div>
                    <div className="detail-row">
                        <span className="detail-label">Organization</span>
                        <span className="detail-value">{userProfile?.orgName ?? '-'}</span>
                    </div>
                    {user?.userRole?.trim().toLowerCase() === 'provider admin' &&
                        <>
                            <div className="detail-row">
                                <span className="detail-label">NPI</span>
                            <span className="detail-value"
                                style={{ overflowWrap: "break-word", wordBreak: "break-word" }}
                            >
                                {userProfile?.npi ?? '-'}
                            </span>
                            </div>
                        </>
                    }
                    
                    {user?.userRole?.trim().toLowerCase() != 'super admin' &&
                        <>
                            <div className="detail-row">
                                <span className="detail-label">Tax ID</span>
                            <span className="detail-value" style={{ overflowWrap: "break-word", wordBreak: "break-word" }}>
                                {
                                    //                                    userProfile?.TaxID ?? '-'
                                    userProfile?.TaxID?.replace(/\|/g, ',') ?? '-'
                                }
                            </span>
                            </div>
                        </>
                    }
                    
                    <div className="detail-row" style={{ gridColumn: '1 / -1' }}>
                        <span className="detail-label">Address</span>
                        <span className="detail-value" style={{ overflowWrap: "break-word", wordBreak: "break-word" }}>
                            {/*{userProfile?.address}, {userProfile?.city}, {userProfile?.state} {userProfile?.zipcode}*/}
                            {[
                                userProfile?.address,
                                userProfile?.city,
                                userProfile?.state,
                                userProfile?.zipcode,
                            ].filter(Boolean).join(', ') || '-'}
                        </span>
                    </div>
                </div>
            </div>

            {/* Edit Profile Section */}
            <div className="card">
                <h3 style={{ margin: '0 0 20px 0', fontSize: 18, fontWeight: 700, color: '#1A1D21' }}>
                    Edit Profile
                </h3>
                <Form                    
                    //  key={JSON.stringify(formData)} 
                    key={userProfile?.email || "profile-form"}                   

                    initialValues={formData}
                    onSubmit={handleSaveProfile}
                    render={(formRenderProps) => {

                        // set initial ONLY once when form loads
                        if (initialTaxIdsRef.current.length === 0) {
                            initialTaxIdsRef.current =
                                formRenderProps.valueGetter('taxIds') || [];
                        }

                        const taxIds = formRenderProps.valueGetter('taxIds') || [];
                        
                        const handleRemoveTaxId = (idx) => {
                            
                            const next = taxIds.filter((_, i) => i !== idx);

                            formRenderProps.onChange('taxIds', {
                                value: next
                            });
                        };

                        const handleAddTaxId = () => {
                            formRenderProps.onChange('taxIds', {
                                value: [...taxIds, '']
                            });
                        };

                        //const taxIdsChanged =
                        //    JSON.stringify(taxIds.map(x => (x ?? '').trim())) !==
                        //    JSON.stringify(initialTaxIdsRef.current.map(x => (x ?? '').trim()));

                        const normalizeTaxIds = (ids = []) =>
                            ids
                                .map(x => (x ?? '').trim())
                                .filter(x => x.length > 0);

                        const taxIdsChanged =
                            JSON.stringify(normalizeTaxIds(taxIds)) !==
                            JSON.stringify(normalizeTaxIds(initialTaxIdsRef.current));

                       // console.log("taxIdsChanged : " + taxIdsChanged);

                         taxIdAttestationRequired = isAdmin && taxIdsChanged;

                      //  console.log("taxIdAttestationRequired : " + taxIdAttestationRequired);


                        return(<FormElement>
                    <div className="form-grid">

                        <Field
                            id="firstName"
                            name="firstName"
                            component={FormInput}
                            //label="First Name"
                            label={
                                <>
                                    First Name <span style={{ color: 'red' }}>*</span>
                                </>
                            }
                            validator={requiredValidatorFirstName}
                        />

                        <Field
                            id="lastName"
                            name="lastName"
                            component={FormInput}
                            //  label="Last Name"
                            label={
                                <>
                                    Last Name <span style={{ color: 'red' }}>*</span>
                                </>
                            }
                            validator={requiredValidatorLastName}
                        />

                        {/*<Field*/}
                        {/*    id="email"*/}
                        {/*    name="email"*/}
                        {/*    component={FormInput}*/}
                        {/*    label="Email"*/}
                        {/*    validator={(value) =>*/}
                        {/*        requiredValidator(value) || emailValidator(value)*/}
                        {/*    }*/}
                        {/*/>*/}

                        <Field
                            id="phone"
                            name="phone"
                            //component={MaskedTextBox}                                    */}
                            component={MaskedTextBoxField}
                            label="Phone"
                            mask="(000) 000-0000"
                            validator={phoneValidator}
                        />

                        {userProfile?.userRole?.toLowerCase?.().trim?.() === 'provider admin' &&
                            <>
                                <Field
                                    id="organizationName"
                                    name="organizationName"
                                    component={FormInput}
                                    label="Organization Name"
                                />
                            </>
                        }


                        {/* ── Admin-only: Tax ID management ──────────────────────
              Renders inline at the bottom of the Edit Profile form
              when the signed-in user is Admin or Super Admin. Lets
              them attach one or more Tax IDs to their account, with
              a regulated-action attestation checkbox surfaced as a
              disclaimer when more than one ID is present. ───────── */}
                        {user?.userRole?.trim().toLowerCase() === 'provider admin' && (
                            //   {isAdmin && (
                            <div data-cy="tax-id-section" style={{ gridColumn: '1 / -1', marginTop: 6 }}>
                                {/* Divider above the section */}
                                <div style={{ height: 1, background: '#E8ECF0', marginBottom: 18 }} />

                                {/* Section header with "Admin only" pill */}
                                <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 14, flexWrap: 'wrap' }}>
                                    <div style={{
                                        width: 36, height: 36, borderRadius: 10,
                                        background: 'rgba(13,148,136,0.10)',
                                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                                        border: '1px solid rgba(13,148,136,0.22)',
                                        flexShrink: 0,
                                    }}>
                                        <Hash size={17} color="#0D9488" strokeWidth={2.5} />
                                    </div>
                                    <div style={{ flex: 1, minWidth: 0 }}>
                                        <div style={{ fontSize: 16, fontWeight: 700, color: '#1A1D21', lineHeight: 1.3 }}>
                                            Tax IDs
                                        </div>
                                        <div style={{ fontSize: 12, color: '#6B7280', marginTop: 2 }}>
                                            Manage one or more Tax IDs associated with your organization.
                                        </div>
                                    </div>
                                    <span
                                        data-cy="admin-only-badge"
                                        style={{
                                        padding: '4px 10px',
                                        fontSize: 10,
                                        fontWeight: 800,
                                        color: '#7C3AED',
                                        background: 'rgba(124,58,237,0.10)',
                                        border: '1px solid rgba(124,58,237,0.22)',
                                        borderRadius: 999,
                                        letterSpacing: '0.06em',
                                        textTransform: 'uppercase',
                                        flexShrink: 0,
                                    }}>
                                        Admin only
                                    </span>
                                </div>

                                {/* Tax ID rows */}


                                <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
                                            {taxIds.map((tid, idx) => (
                                        <div key={idx} style={{ display: 'flex', gap: 8, alignItems: 'flex-end' }}>
                                            <div style={{ flex: 1, minWidth: 0 }}>
                                                {/*<ValidatedInput*/}

                                                {/*    label={idx === 0 ? 'Primary Tax ID' : `Additional Tax ID #${idx + 1}`}*/}
                                                {/*    // value={tid}*/}
                                                {/*    value={tid ?? ''}*/}
                                                {/*    onChange={(v) => handleTaxIdChange(idx, v)}*/}
                                                {/*    placeholder="e.g. 12-3456789"*/}
                                                {/*/>*/}

                                                {/*<Field*/}

                                                {/*    label={idx === 0 ? 'Primary Tax ID' : `Additional Tax ID #${idx + 1}`}*/}
                                                {/*    // value={tid}*/}
                                                {/*   // value={tid ?? ''}*/}
                                                {/*    onChange={(v) => handleTaxIdChange(idx, v)}*/}
                                                {/*    placeholder="e.g. 12-3456789"*/}

                                                {/*    name={`taxIds[${idx}]`}*/}
                                                {/*    component={FormInput}*/}
                                                {/*    label={idx === 0 ? 'Primary Tax ID' : `Additional Tax ID #${idx + 1}`}*/}

                                                {/*/>*/}
                                                <Field
                                                            name={`taxIds[${idx}]`}
                                                            data-cy={`tax-id-${idx}`}
                                                            /*component={FormInput}*/
                                                            placeholder="e.g. 12-3456789"
                                                            component={MaskedTextBoxField}                                                            
                                                            mask="00-0000000"
                                                    label={idx === 0 ? 'Primary Tax ID' : `Additional Tax ID #${idx + 1}`}
                                                />
                                            </div>
                                                    {taxIds.length > 1 && (
                                                        <button
                                                            data-cy={`remove-tax-id-${idx}`}
                                                    type="button"
                                                            onClick={() => handleRemoveTaxId((formRenderProps,idx))}
                                                    title="Remove this Tax ID"
                                                    aria-label={`Remove Tax ID #${idx + 1}`}
                                                    style={{
                                                        padding: '9px 11px',
                                                        background: 'rgba(220,38,38,0.06)',
                                                        color: '#B91C1C',
                                                        border: '1px solid rgba(220,38,38,0.22)',
                                                        borderRadius: 8,
                                                        cursor: 'pointer',
                                                        display: 'inline-flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                        flexShrink: 0,
                                                        fontFamily: 'inherit',
                                                    }}
                                                >
                                                    <Trash2 size={14} strokeWidth={2.5} />
                                                </button>
                                            )}
                                        </div>
                                    ))}
                                </div>

                                {/* Add Tax ID button */}
                                <div style={{ marginTop: 12 }}>
                                            <button
                                                data-cy="add-tax-id-btn"
                                        type="button"
                                                onClick={() => handleAddTaxId(formRenderProps)}
                                        style={{
                                            padding: '8px 14px',
                                            background: '#fff',
                                            color: '#0D9488',
                                            border: '1px dashed rgba(13,148,136,0.45)',
                                            borderRadius: 8,
                                            cursor: 'pointer',
                                            fontSize: 13,
                                            fontWeight: 700,
                                            display: 'inline-flex',
                                            alignItems: 'center',
                                            gap: 6,
                                            fontFamily: 'inherit',
                                        }}
                                    >
                                        <Plus size={14} strokeWidth={2.8} /> Add another Tax ID
                                    </button>
                                </div>

                                {/* Attestation disclaimer — appears whenever the Tax IDs have
                  been edited from their initial state (editing the Primary
                  Tax ID counts, so does adding/changing additional IDs).
                  Save is blocked until the box is checked. */}
                                {taxIdAttestationRequired && (
                                    <div style={{
                                        marginTop: 14,
                                        padding: '12px 14px',
                                        background: 'rgba(245,158,11,0.07)',
                                        border: '1px solid rgba(245,158,11,0.35)',
                                        borderRadius: 10,
                                        display: 'flex',
                                        gap: 12,
                                        alignItems: 'flex-start',
                                    }}>
                                        <AlertTriangle
                                            size={18}
                                            color="#B45309"
                                            strokeWidth={2.5}
                                            style={{ flexShrink: 0, marginTop: 1 }}
                                        />
                                        <div style={{ flex: 1, minWidth: 0 }}>
                                            <div style={{ fontSize: 13, fontWeight: 700, color: '#92400E', marginBottom: 6 }}>
                                                Administrator attestation required
                                            </div>
                                            <label style={{
                                                display: 'flex',
                                                gap: 8,
                                                alignItems: 'flex-start',
                                                cursor: 'pointer',
                                                fontSize: 12,
                                                color: '#92400E',
                                                lineHeight: 1.55,
                                            }}>
                                                <input
                                                    data-cy="tax-id-attestation"
                                                    type="checkbox"
                                                    checked={formData.taxIdAttestation}
                                                    onChange={(e) => handleProfileChange('taxIdAttestation', e.target.checked)}
                                                    style={{ marginTop: 3, flexShrink: 0, accentColor: '#B45309' }}
                                                />
                                                <span>
                                                    I acknowledge as an Administrator that the Tax ID(s) entered above
                                                    belong to me or to the organization I represent, and that I am
                                                    authorized to associate them with this account.
                                                </span>
                                            </label>
                                        </div>
                                    </div>
                                )}
                            </div>
                        )}

                    </div>


                    <div className="form-actions">
                        <Button
                            className="btn-primary"
                            type="submit"
                            //  disabled={!formRenderProps.allowSubmit || savingProfile}
                            disabled={
                                savingProfile ||
                                (!formRenderProps.modified && !taxIdsChanged)
                            }

                        >
                            {savingProfile ? 'Saving...' : 'Save Changes'}
                        </Button>


                    </div>
                </FormElement>
                                );

                        
                    }}
                />
            </div>

            <div>
            
        </div>


            {/* Change Password */}

            <div className="card">
                <h3 style={{ margin: '0 0 20px 0', fontSize: 18, fontWeight: 700, color: '#1A1D21' }}>
                    Change Password
                </h3>
                <div className="form-grid">
                    <div className="form-group" style={{ gridColumn: '1 / -1' }}>

                        <Form 
                            onSubmit={handleUpdatePassword}
                            render={(formRenderProps) => (
                                <FormElement>
                                    <div className="form-grid">

                                        {/*<Field*/}
                                        {/*    type="password"*/}
                                        {/*    id="currentPassword"                                           */}
                                        {/*    name="currentPassword"                                           */}
                                            
                                        {/*    label="Current Password"*/}
                                        {/*    validator={requiredValidator}*/}
                                        {/*    component={FormInput}*/}
                                        {/*/>*/}

                                        <Field
                                            type={pwdReveal ? "text" : "password"}
                                            id="currentPassword"
                                            name="currentPassword"
                                            // label="Current Password"
                                            label={
                                                <>
                                                    Current Password <span style={{ color: 'red' }}>*</span>
                                                </>
                                            }
                                            validator={requiredValidatorCurrentPassword}
                                            component={FormInput}
                                        />

                                        
                                        {/*Action row: Generate / Show / Copy */}
                                        {/*  FORCE NEW ROW */}
                                        <div
                                            style={{
                                                gridColumn: "1 / -1",   // ⭐ IMPORTANT FIX
                                                marginTop: 8,
                                                marginBottom: 16
                                            }}
                                        >
                                        <div style={{
                                            display: 'flex',
                                            gap: 8,
                                            flexWrap: 'wrap',
                                            alignItems: 'center',
                                            marginBottom: 12,
                                        }}>
                                            <button
                                                type="button"
                                                onClick={async () => {
                                                    const pwd = generatePassword();

                                                    // $('#newPassword').val(pwd);

                                                    formRenderProps.onChange("newPassword", { value: pwd });
                                                    formRenderProps.onChange("confirmPassword", { value: pwd });

                                                    setPwdNew(pwd);
                                                    setPwdConfirm(pwd);
                                                    setPwdReveal(true);
                                                    try {
                                                        await navigator.clipboard?.writeText(pwd);
                                                        toast.success(
                                                            'Strong password generated and copied to clipboard. Share it with the user securely.',
                                                            { title: 'Password generated' }
                                                        );
                                                    } catch {
                                                        toast.info(
                                                            'Strong password generated. Copy it manually before saving — it will not be shown again.',
                                                            { title: 'Password generated' }
                                                        );
                                                    }
                                                }}
                                                style={{
                                                    padding: '8px 14px', borderRadius: 10,
                                                    border: '1px solid rgba(124,58,237,0.3)',
                                                    background: 'rgba(124,58,237,0.08)',
                                                    color: '#7C3AED', fontSize: 13, fontWeight: 700,
                                                    cursor: 'pointer', fontFamily: 'inherit',
                                                    display: 'inline-flex', alignItems: 'center', gap: 6,
                                                }}
                                                title="Generate a strong random password"
                                            >
                                                <Key size={13} strokeWidth={2.5} />
                                                Generate Password
                                            </button>
                                            <button
                                                type="button"
                                                onClick={() => setPwdReveal((r) => !r)}
                                                style={{
                                                    padding: '8px 12px', borderRadius: 10,
                                                    border: '1px solid #E8ECF0',
                                                    background: '#fff',
                                                    color: '#6B7280', fontSize: 13, fontWeight: 600,
                                                    cursor: 'pointer', fontFamily: 'inherit',
                                                    display: 'inline-flex', alignItems: 'center', gap: 6,
                                                }}
                                                title={pwdReveal ? 'Hide password' : 'Show password'}
                                            >
                                                {pwdReveal
                                                    ? <><EyeOff size={13} strokeWidth={2} /> Hide</>
                                                    : <><Eye size={13} strokeWidth={2} /> Show</>}
                                            </button>
                                            {pwdNew && (
                                                <button
                                                    type="button"
                                                    onClick={async () => {
                                                        try {
                                                            await navigator.clipboard?.writeText(pwdNew);
                                                            toast.success('Password copied to clipboard.', { title: 'Copied' });
                                                        } catch {
                                                            toast.error('Could not copy — clipboard access denied.', { title: 'Copy failed' });
                                                        }
                                                    }}
                                                    style={{
                                                        padding: '8px 12px', borderRadius: 10,
                                                        border: '1px solid #E8ECF0',
                                                        background: '#fff',
                                                        color: '#6B7280', fontSize: 13, fontWeight: 600,
                                                        cursor: 'pointer', fontFamily: 'inherit',
                                                        display: 'inline-flex', alignItems: 'center', gap: 6,
                                                    }}
                                                    title="Copy current password to clipboard"
                                                >
                                                    <Copy size={13} strokeWidth={2} /> Copy
                                                </button>
                                            )}
                                        </div>


                                        </div>

                                        <Field
                                            type="password"
                                            id="newPassword"                                    
                                            name="newPassword"                                    
                                            //label="New Password"
                                            label={
                                                <>
                                                    New Password <span style={{ color: 'red' }}>*</span>
                                                </>
                                            }
                                            validator={[requiredValidatorNewPassword, strongPasswordValidator]}                                            
                                            component={FormInput}
                                        />

                                        <Field
                                            type="password"
                                            id="confirmPassword"                                       
                                            name="confirmPassword"                          
                                            
                                            //label="Confirm Password"
                                            label={
                                                <>
                                                    Confirm Password <span style={{ color: 'red' }}>*</span>
                                                </>
                                            }
                                            validator={[requiredValidatorConfirmPassword, matchPasswordValidator(() => formRenderProps.valueGetter?.("newPassword"))]}                                            
                                            component={FormInput}
                                        />
                                    </div>

                                    <div className="form-actions">
                                        <Button
                                            className="btn-primary"
                                            type="submit"
                                            disabled={!formRenderProps.allowSubmit || savingPassword}
                                        >
                                            {savingPassword ? 'Updating...' : 'Update Password'}
                                        </Button>


                                    </div>
                                </FormElement>
                            )}
                        />
                    </div>
                    
                </div>
                
            </div>

            {/* Two-Factor Authentication */}
            {/*<div className="card">*/}
            {/*    <div*/}
            {/*        style={{*/}
            {/*            display: 'flex',*/}
            {/*            alignItems: 'center',*/}
            {/*            justifyContent: 'space-between',*/}
            {/*            padding: '16px 18px',*/}
            {/*            borderRadius: 16,*/}
            {/*            border: '1px solid #E8ECF0',*/}
            {/*            background: '#F9FAFB'*/}
            {/*        }}*/}
            {/*    >*/}
            {/*        */}{/* Left Content */}
            {/*        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>*/}

            {/*            */}{/* Icon */}
            {/*            <div*/}
            {/*                style={{*/}
            {/*                    width: 42,*/}
            {/*                    height: 42,*/}
            {/*                    borderRadius: 12,*/}
            {/*                    background: '#EEF2F7',*/}
            {/*                    display: 'flex',*/}
            {/*                    alignItems: 'center',*/}
            {/*                    justifyContent: 'center',*/}
            {/*                    fontSize: 18*/}
            {/*                }}*/}
            {/*            >*/}
            {/*                🔒*/}
            {/*            </div>*/}

            {/*            */}{/* Text */}
            {/*            <div>*/}
            {/*                <div style={{ fontWeight: 600, fontSize: 15 }}>*/}
            {/*                    Two-Factor Authentication*/}
            {/*                </div>*/}
            {/*                <div style={{ fontSize: 13, color: '#6B7280' }}>*/}
            {/*                    Add an extra layer of security to your account by enabling 2FA.*/}
            {/*                </div>*/}
            {/*            </div>*/}
            {/*        </div>*/}

            {/*        */}{/* Kendo Switch */}
            {/*        <Switch*/}
            {/*            checked={twoFactorEnabled}*/}
            {/*            onChange={(e) => handleToggle2FA(e.value)}*/}
            {/*        />*/}
            {/*    </div>*/}
            {/*</div>*/}


            {/* ── Security & Authentication ─────────────────────────── */}
            <div className="card">
                {/* Parent header */}
                <div style={{ display: 'flex', alignItems: 'flex-start', gap: 14, marginBottom: 18 }}>
                    <div style={{
                        width: 48, height: 48, borderRadius: 14,
                        background: 'linear-gradient(135deg, #EDE9FE, #DDD6FE)',
                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                        flexShrink: 0,
                        border: '1px solid rgba(124, 58, 237, 0.15)',
                    }}>
                        <ShieldCheck size={22} color="#7C3AED" strokeWidth={2.5} />
                    </div>
                    <div>
                        <h3 style={{ margin: 0, fontSize: 20, fontWeight: 800, color: '#1A1D21', letterSpacing: '-0.3px' }}>
                            Security &amp; Authentication
                        </h3>
                        <p style={{ margin: '4px 0 0 0', fontSize: 14, color: '#6B7280', lineHeight: 1.5 }}>
                            Keep your account safe with 2FA and strong passwords.
                        </p>
                    </div>
                </div>

                {/* Nested 2FA card */}
                <div style={{
                    padding: 18,
                    borderRadius: 16,
                    background: '#F8FAFB',
                    border: '1px solid #E8ECF0',
                }}>
                    <div style={{
                        display: 'flex', alignItems: 'center',
                        justifyContent: 'space-between', gap: 16, flexWrap: 'wrap',
                    }}>
                        <div style={{ display: 'flex', alignItems: 'flex-start', gap: 14, flex: 1, minWidth: 220 }}>
                            {/* Red shield icon */}
                            <div style={{
                                width: 44, height: 44, borderRadius: 12,
                                background: 'rgba(239, 68, 68, 0.1)',
                                display: 'flex', alignItems: 'center', justifyContent: 'center',
                                flexShrink: 0,
                                border: '1px solid rgba(239, 68, 68, 0.2)',
                            }}>
                                <Shield size={22} color="#DC2626" strokeWidth={2.5} />
                            </div>
                            <div style={{ flex: 1, minWidth: 0 }}>
                                <div style={{ fontSize: 17, fontWeight: 700, color: '#1A1D21', lineHeight: 1.3 }}>
                                    Two Factor Authentication
                                </div>
                                <div style={{ fontSize: 13, color: '#6B7280', marginTop: 4, lineHeight: 1.5 }}>
                                    {mfaEmailEnabled ? (
                                        <>
                                            A 6-digit code will be sent to{' '}
                                            <strong style={{ color: '#1A1D21' }}>{user?.email}</strong>{' '}
                                            each time you sign in.
                                        </>
                                    ) : (
                                        <>Add an extra layer of security to your account by enabling 2FA.</>
                                    )}
                                </div>
                            </div>
                        </div>

                        {/* ON/OFF pill toggle */}
                        {emailMfaStep === 'idle' && (
                            <button
                                name="btnChange2FA"
                                type="button"
                                role="switch"
                                aria-checked={mfaEmailEnabled}
                                aria-label={mfaEmailEnabled ? 'Turn off 2FA' : 'Turn on 2FA'}
                                onClick={() => (mfaEmailEnabled ? handleDisableEmailMfa() : handleBeginEnableEmailMfa())}
                                disabled={emailMfaSaving}
                                style={{
                                    width: 96, height: 38, borderRadius: 999,
                                    border: `1.5px solid ${mfaEmailEnabled ? '#0D9488' : '#D1D5DB'}`,
                                    background: mfaEmailEnabled ? '#0D9488' : '#fff',
                                    cursor: emailMfaSaving ? 'wait' : 'pointer',
                                    padding: 3,
                                    position: 'relative',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: mfaEmailEnabled ? 'flex-start' : 'flex-end',
                                    flexShrink: 0,
                                    transition: 'all 0.2s',
                                    fontFamily: 'inherit',
                                }}
                            >
                                {/* White circle knob */}
                                <span style={{
                                    width: 30, height: 30, borderRadius: '50%',
                                    background: '#fff',
                                    boxShadow: '0 2px 6px rgba(0,0,0,0.15)',
                                    flexShrink: 0,
                                    transition: 'transform 0.2s',
                                }} />
                                {/* ON / OFF text label on opposite side */}
                                <span name="span2FAText" style={{
                                    position: 'absolute',
                                    left: mfaEmailEnabled ? 40 : 12,
                                    right: mfaEmailEnabled ? 12 : 40,
                                    textAlign: mfaEmailEnabled ? 'left' : 'right',
                                    fontSize: 12,
                                    fontWeight: 700,
                                    letterSpacing: 0.5,
                                    color: mfaEmailEnabled ? '#fff' : '#6B7280',
                                    transition: 'color 0.2s',
                                }}>
                                    {mfaEmailEnabled ? 'ON' : 'OFF'}
                                </span>
                            </button>
                        )}
                    </div>

                    {emailMfaError && (
                        <div className="error-text" style={{ marginTop: 14 }}>{emailMfaError}</div>
                    )}

                    {/* Verify step: show when enabling (must confirm code from email) */}
                    {emailMfaStep === 'verify' && (
                        <div style={{
                            marginTop: 16, padding: 16, borderRadius: 12,
                            background: '#fff', border: '1px solid #E8ECF0',
                        }}>
                            <div style={{ display: 'flex', alignItems: 'flex-start', gap: 12, marginBottom: 14 }}>
                                <Mail size={18} color="#0D9488" strokeWidth={2} style={{ marginTop: 2 }} />
                                <div>
                                    <div style={{ fontSize: 14, fontWeight: 600, color: '#1A1D21', marginBottom: 2 }}>
                                        Check your email
                                    </div>
                                    <div style={{ fontSize: 13, color: '#6B7280' }}>
                                        We've sent a 6-digit verification code to{' '}
                                        <strong style={{ color: '#1A1D21' }}>{user?.email || 'your email address'}</strong>.
                                        Enter it below to enable Two Factor Authentication.
                                    </div>
                                </div>
                            </div>

                            <div className="form-group" style={{ marginBottom: 12 }}>
                                <label>Verification code</label>
                                <input
                                    type="text"
                                    maxLength={6}
                                    placeholder="000000"
                                    value={emailMfaCode}
                                    onChange={(e) => {
                                        setEmailMfaCode(e.target.value.replace(/\D/g, '').slice(0, 6));
                                        setEmailMfaError('');
                                    }}
                                    style={{
                                        letterSpacing: 8, fontSize: 20, fontWeight: 700,
                                        textAlign: 'center', maxWidth: 240,
                                    }}
                                />
                            </div>
                            {/*<div style={{ fontSize: 12, color: '#6B7280', marginBottom: 14 }}>*/}
                            {/*    Demo mode: enter <strong style={{ color: '#0D9488' }}>123456</strong> to confirm.*/}
                            {/*</div>*/}

                            <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap' }}>
                                <button
                                    name="btnCancle2FAEnable"
                                    className="btn-secondary"
                                    onClick={() => { setEmailMfaStep('idle'); setEmailMfaCode(''); setEmailMfaError(''); }}
                                >
                                    Cancel
                                </button>
                                <button
                                    className="btn-primary"
                                    disabled={emailMfaCode.length !== 6 || emailMfaSaving}
                                    style={{ opacity: emailMfaCode.length !== 6 ? 0.5 : 1 }}
                                    onClick={handleConfirmEnableEmailMfa}
                                >
                                    {emailMfaSaving ? 'Verifying...' : 'Verify & Enable'}
                                </button>
                                <button
                                    name="btnResend2FACode"
                                    className="btn-secondary"
                                    disabled={emailMfaSaving}
                                    onClick={handleBeginEnableEmailMfa}
                                    title="Resend code to email"
                                >
                                    Resend Code
                                </button>
                            </div>
                        </div>
                    )}
                </div>
            </div>

            {/* Legacy multi-method 2FA card removed — unified into the
          "Security & Authentication" card above (email-only MFA). */}
            {false && (
                <div className="card">
                    <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 20 }}>
                        <div style={{
                            width: 40, height: 40, borderRadius: 12,
                            background: twoFaEnabled ? 'linear-gradient(135deg, #059669, #10B981)' : 'linear-gradient(135deg, #9CA3AF, #6B7280)',
                            display: 'flex', alignItems: 'center', justifyContent: 'center',
                        }}>
                            <ShieldCheck size={20} color="#fff" strokeWidth={2} />
                        </div>
                        <div>
                            <h3 style={{ margin: 0, fontSize: 18, fontWeight: 700, color: '#1A1D21' }}>
                                Two-Factor Authentication (2FA)
                            </h3>
                            <div style={{ fontSize: 13, color: '#6B7280', marginTop: 2 }}>
                                {twoFaEnabled
                                    ? <span style={{ color: '#059669', fontWeight: 600 }}>Enabled</span>
                                    : 'Add an extra layer of security to your account'
                                }
                            </div>
                        </div>
                    </div>

                    {twoFaError && (
                        <div className="error-text" style={{ marginBottom: 16 }}>{twoFaError}</div>
                    )}

                    {/* 2FA Enabled State */}
                    {twoFaEnabled && twoFaSetupStep === null && (
                        <div>
                            <div style={{
                                padding: 16, borderRadius: 12, background: 'rgba(16,185,129,0.06)',
                                border: '1px solid rgba(16,185,129,0.2)', marginBottom: 16,
                                display: 'flex', alignItems: 'center', gap: 12,
                            }}>
                                <ShieldCheck size={20} color="#059669" />
                                <div>
                                    <div style={{ fontSize: 14, fontWeight: 600, color: '#059669' }}>2FA is active</div>
                                    <div style={{ fontSize: 13, color: '#6B7280' }}>
                                        Method: <strong style={{ color: '#1A1D21' }}>
                                            {twoFaMethod === 'email' ? 'Email verification' : twoFaMethod === 'sms' ? 'SMS verification' : 'Authenticator app'}
                                        </strong>
                                    </div>
                                </div>
                            </div>
                            <div style={{ display: 'flex', gap: 12 }}>
                                <button
                                    className="btn-secondary"
                                    onClick={() => setTwoFaSetupStep('choose')}
                                >
                                    Change Method
                                </button>
                                <button
                                    style={{
                                        padding: '10px 22px', borderRadius: 14, border: '1.5px solid rgba(239,68,68,0.3)',
                                        background: 'rgba(239,68,68,0.06)', color: '#DC2626', fontWeight: 600,
                                        fontSize: 14, cursor: 'pointer', fontFamily: 'inherit',
                                    }}
                                    onClick={() => {
                                        setTwoFaEnabled(false);
                                        setTwoFaSetupStep(null);
                                        setTwoFaMethod('email');
                                        if (isApiConfigured()) profileApi.updateProfile({ twoFactorEnabled: false }).catch(() => { });
                                    }}
                                >
                                    Disable 2FA
                                </button>
                            </div>
                        </div>
                    )}

                    {/* 2FA Disabled - Enable Button */}
                    {!twoFaEnabled && twoFaSetupStep === null && (
                        <button
                            className="btn-primary"
                            onClick={() => setTwoFaSetupStep('choose')}
                        >
                            Enable Two-Factor Authentication
                        </button>
                    )}

                    {/* Step 1: Choose Method */}
                    {twoFaSetupStep === 'choose' && (
                        <div>
                            <div style={{ fontSize: 14, fontWeight: 600, color: '#1A1D21', marginBottom: 12 }}>
                                Select your preferred 2FA method:
                            </div>
                            <div style={{ display: 'flex', flexDirection: 'column', gap: 10, marginBottom: 20 }}>
                                {[
                                    { key: 'email', icon: Mail, label: 'Email Verification', desc: 'Receive a code via email each time you sign in' },
                                    { key: 'sms', icon: Smartphone, label: 'SMS Verification', desc: 'Receive a code via text message to your phone' },
                                    { key: 'authenticator', icon: Key, label: 'Authenticator App', desc: 'Use Google Authenticator, Authy, or similar app' },
                                ].map(opt => {
                                    const Icon = opt.icon;
                                    const selected = twoFaMethod === opt.key;
                                    return (
                                        <div
                                            key={opt.key}
                                            onClick={() => { setTwoFaMethod(opt.key); setTwoFaError(''); }}
                                            style={{
                                                display: 'flex', alignItems: 'center', gap: 14,
                                                padding: '16px 18px', borderRadius: 14, cursor: 'pointer',
                                                border: `1.5px solid ${selected ? '#0D9488' : '#E8ECF0'}`,
                                                background: selected ? 'rgba(13,148,136,0.04)' : '#fff',
                                                transition: 'all 0.15s',
                                            }}
                                        >
                                            <div style={{
                                                width: 40, height: 40, borderRadius: 10, flexShrink: 0,
                                                background: selected ? 'linear-gradient(135deg, #0F766E, #0D9488)' : '#F1F5F9',
                                                display: 'flex', alignItems: 'center', justifyContent: 'center',
                                            }}>
                                                <Icon size={18} color={selected ? '#fff' : '#6B7280'} strokeWidth={2} />
                                            </div>
                                            <div style={{ flex: 1 }}>
                                                <div style={{ fontSize: 14, fontWeight: 600, color: '#1A1D21' }}>{opt.label}</div>
                                                <div style={{ fontSize: 12, color: '#6B7280' }}>{opt.desc}</div>
                                            </div>
                                            <div style={{
                                                width: 20, height: 20, borderRadius: '50%', flexShrink: 0,
                                                border: `2px solid ${selected ? '#0D9488' : '#D1D5DB'}`,
                                                display: 'flex', alignItems: 'center', justifyContent: 'center',
                                            }}>
                                                {selected && <div style={{ width: 10, height: 10, borderRadius: '50%', background: '#0D9488' }} />}
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                            <div style={{ display: 'flex', gap: 12 }}>
                                <button
                                    className="btn-secondary"
                                    onClick={() => { setTwoFaSetupStep(null); setTwoFaError(''); }}
                                >
                                    Cancel
                                </button>
                                <button
                                    className="btn-primary"
                                    onClick={async () => {
                                        setTwoFaSaving(true);
                                        setTwoFaError('');
                                        try {
                                            if (isApiConfigured()) {
                                                await profileApi.updateProfile({ twoFactorMethod: twoFaMethod });
                                            } else {
                                                await new Promise(r => setTimeout(r, 800));
                                            }
                                            setTwoFaSetupStep('verify');
                                        } catch {
                                            setTwoFaError('Failed to initiate 2FA setup. Please try again.');
                                        } finally {
                                            setTwoFaSaving(false);
                                        }
                                    }}
                                    disabled={twoFaSaving}
                                >
                                    {twoFaSaving ? 'Setting up...' : 'Continue'}
                                </button>
                            </div>
                        </div>
                    )}

                    {/* Step 2: Verify Code */}
                    {twoFaSetupStep === 'verify' && (
                        <div>
                            <div style={{
                                padding: 16, borderRadius: 12, background: '#F8FAFB',
                                border: '1px solid #E8ECF0', marginBottom: 20,
                            }}>
                                {twoFaMethod === 'authenticator' ? (
                                    <div style={{ textAlign: 'center' }}>
                                        <div style={{ fontSize: 14, fontWeight: 600, color: '#1A1D21', marginBottom: 8 }}>
                                            Scan QR Code with your authenticator app
                                        </div>
                                        {/* Mock QR code placeholder */}
                                        <div style={{
                                            width: 160, height: 160, margin: '12px auto', borderRadius: 12,
                                            background: '#fff', border: '2px solid #E8ECF0',
                                            display: 'flex', alignItems: 'center', justifyContent: 'center',
                                            fontSize: 12, color: '#9CA3AF',
                                        }}>
                                            <div style={{ textAlign: 'center' }}>
                                                <Key size={32} color="#D1D5DB" style={{ marginBottom: 4 }} />
                                                <div>QR Code</div>
                                                <div style={{ fontSize: 10 }}>(Generated by API)</div>
                                            </div>
                                        </div>
                                        <div style={{ fontSize: 12, color: '#6B7280', marginTop: 8 }}>
                                            Or enter this key manually: <strong style={{ color: '#1A1D21', letterSpacing: 1 }}>DEMO-XXXX-XXXX-XXXX</strong>
                                        </div>
                                    </div>
                                ) : (
                                    <div>
                                        <div style={{ fontSize: 14, fontWeight: 600, color: '#1A1D21', marginBottom: 4 }}>
                                            {twoFaMethod === 'email' ? 'Check your email' : 'Check your phone'}
                                        </div>
                                        <div style={{ fontSize: 13, color: '#6B7280' }}>
                                            We've sent a 6-digit verification code to{' '}
                                            <strong style={{ color: '#1A1D21' }}>
                                                {twoFaMethod === 'email' ? (user?.email || 'your email') : (user?.phone || 'your phone')}
                                            </strong>
                                        </div>
                                    </div>
                                )}
                            </div>

                            <div className="form-group" style={{ marginBottom: 16 }}>
                                <label>Enter 6-digit verification code</label>
                                <input
                                    type="text"
                                    maxLength={6}
                                    placeholder="000000"
                                    value={twoFaCode}
                                    onChange={e => { setTwoFaCode(e.target.value.replace(/\D/g, '').slice(0, 6)); setTwoFaError(''); }}
                                    style={{ letterSpacing: 8, fontSize: 20, fontWeight: 700, textAlign: 'center', maxWidth: 240 }}
                                />
                            </div>

                            {/*<div style={{ fontSize: 12, color: '#6B7280', marginBottom: 16 }}>*/}
                            {/*    Demo mode: Enter <strong style={{ color: '#0D9488' }}>123456</strong> to verify*/}
                            {/*</div>*/}

                            <div style={{ display: 'flex', gap: 12 }}>
                                <button
                                    className="btn-secondary"
                                    onClick={() => { setTwoFaSetupStep('choose'); setTwoFaCode(''); setTwoFaError(''); }}
                                >
                                    Back
                                </button>
                                <button
                                    className="btn-primary"
                                    disabled={twoFaCode.length !== 6 || twoFaSaving}
                                    style={{ opacity: twoFaCode.length !== 6 ? 0.5 : 1 }}
                                    onClick={async () => {
                                        setTwoFaSaving(true);
                                        setTwoFaError('');
                                        try {
                                            if (isApiConfigured()) {
                                                await profileApi.updateProfile({ twoFactorEnabled: true, twoFactorMethod: twoFaMethod, verificationCode: twoFaCode });
                                            } else {
                                                await new Promise(r => setTimeout(r, 800));
                                                if (twoFaCode !== '123456') throw new Error('Invalid code');
                                            }
                                            setTwoFaEnabled(true);
                                            setTwoFaSetupStep(null);
                                            setTwoFaCode('');
                                        } catch {
                                            setTwoFaError('Invalid verification code. Please try again.');
                                        } finally {
                                            setTwoFaSaving(false);
                                        }
                                    }}
                                >
                                    {twoFaSaving ? 'Verifying...' : 'Verify & Enable'}
                                </button>
                            </div>
                        </div>
                    )}
                </div>
            )}

            {/* Sign-in Activity / Audit trail */}
            {user?.userId && <LoginActivityCard userId={user.userId} />}

            {/* Impersonation activity / Audit trail */}
            {user?.userId && user?.userRole?.trim().toLowerCase()==='super admin' && <ImpersonationActivityCard userId={user.userId}  />}

             {/*Notification Preferences */}
            <div className="card">
                <h3 style={{ margin: '0 0 20px 0', fontSize: 18, fontWeight: 700, color: '#1A1D21' }}>
                    Notification Preferences
                </h3>
                <p style={{ margin: '0 0 20px 0', fontSize: 14, color: '#6B7280' }}>
                    Choose which email notifications you would like to receive.
                </p>

                <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
                    {[
                        { key: 'claims', label: 'Claims', desc: 'Updates on claim status changes, denials, and payments' },
                        //{ key: 'authorizations', label: 'Authorizations', desc: 'Prior authorization decisions and expiration reminders' },
                        { key: 'invoices', label: 'Invoices', desc: 'New invoices, payment confirmations, and overdue notices' },
                        { key: 'systemUpdates', label: 'System Updates', desc: 'Scheduled maintenance, new features, and portal announcements' },
                    ].map((item) => (
                        <label
                            key={item.key}
                            style={{
                                display: 'flex',
                                alignItems: 'flex-start',
                                gap: 14,
                                padding: '14px 16px',
                                borderRadius: 14,
                                border: '1px solid #E8ECF0',
                                cursor: 'pointer',
                                transition: 'all 0.15s ease',
                                background: notifications[item.key] ? 'rgba(13,148,136,0.04)' : '#fff',
                                borderColor: notifications[item.key] ? 'rgba(13,148,136,0.2)' : '#E8ECF0',
                            }}
                        >
                            <input
                                type="checkbox"
                                checked={notifications[item.key]}
                                onChange={() => handleNotificationChange(item.key)}
                                style={{
                                    width: 18,
                                    height: 18,
                                    accentColor: '#0D9488',
                                    marginTop: 2,
                                    cursor: 'pointer',
                                    flexShrink: 0,
                                }}
                            />
                            <div>
                                <div style={{ fontSize: 14, fontWeight: 600, color: '#1A1D21', marginBottom: 2 }}>
                                    {item.label}
                                </div>
                                <div style={{ fontSize: 13, color: '#6B7280', lineHeight: 1.4 }}>
                                    {item.desc}
                                </div>
                            </div>
                        </label>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default ProfilePage;
